import UniversalCookie, { CookieSetOptions } from 'universal-cookie';

export type CookieValue = string | boolean;
export type CookieOptions = CookieSetOptions;

class Cookie {
  private _client: UniversalCookie = new UniversalCookie();

  public init(header: string) {
    this._client = new UniversalCookie(header);
  }

  public get = (key: string): string => {
    return this._client.get(key);
  };

  public set = (
    key: string,
    value: CookieValue,
    options?: CookieOptions,
  ): void => {
    this._client.set(key, value, options);
  };

  public remove = (key: string) => {
    this._client.remove(key);
  };
}

const cookie = new Cookie();

export const init = (header: string) => cookie.init(header);
export const get = (key: string) => cookie.get(key);
export const set = (key: string, value: CookieValue, options?: CookieOptions) =>
  cookie.set(key, value, options);
export const remove = (key: string) => cookie.remove(key);

export default cookie;
